<div class="ac-page c7-access-view c7-access-register">

  <header class="ac-topbar">
    <div class="ac-topbar__inner">
      <a class="ac-brand" href="javascript:void(0)" aria-label="CULTURA">
        <img src="assets/logo-blue.png" alt="CULTURA" class="ac-brand__logo" />
      </a>
      <label class="ac-lang">
        <span>{{ "acceptPage.language" | translate }}</span>
        <select [value]="selectedLanguage" (change)="changeLanguage($any($event.target).value)">
          <option *ngFor="let language of supportedLanguages" [value]="language.code">{{ language.name }}</option>
        </select>
      </label>
    </div>
  </header>

  <main class="ac-main ac-main--center">
    <section class="ac-card ac-card--wide" aria-labelledby="ac-title">
      <div class="ac-card__head">
        <h2 id="ac-title">{{ "contactPage.title" | translate }}</h2>
        <p class="ac-card__sub">{{ "contactPage.sub" | translate }}</p>
      </div>

      <form [formGroup]="signupForm" (ngSubmit)="signUp()" novalidate class="ac-form">
        <div class="ac-row">
        <div class="ac-field">
          <label for="ac-fname">{{ "form.firstname" | translate }}</label>
          <input id="ac-fname" type="text" formControlName="first_name" autocomplete="given-name"
            [attr.aria-invalid]="(submitted || f['first_name'].touched) && f['first_name'].invalid ? 'true' : 'false'" />
          <span class="ac-error" *ngIf="(submitted || f['first_name'].touched) && f['first_name'].hasError('required')" aria-live="polite">{{ "signup.firstName" | translate }}</span>
        </div>
        <div class="ac-field">
          <label for="ac-lname">{{ "form.lastname" | translate }}</label>
          <input id="ac-lname" type="text" formControlName="last_name" autocomplete="family-name"
            [attr.aria-invalid]="(submitted || f['last_name'].touched) && f['last_name'].invalid ? 'true' : 'false'" />
          <span class="ac-error" *ngIf="(submitted || f['last_name'].touched) && f['last_name'].hasError('required')" aria-live="polite">{{ "signup.LastName" | translate }}</span>
        </div>
        </div>
        <div class="ac-field">
          <label for="ac-company">{{ "form.company" | translate }}</label>
          <input id="ac-company" type="text" formControlName="company" autocomplete="organization"
            [attr.aria-invalid]="(submitted || f['company'].touched) && f['company'].invalid ? 'true' : 'false'" />
          <span class="ac-error" *ngIf="(submitted || f['company'].touched) && f['company'].hasError('required')" aria-live="polite">{{ "signup.Company" | translate }}</span>
        </div>
        <div class="ac-field">
          <label for="ac-email">{{ "form.email" | translate }}</label>
          <input id="ac-email" type="email" formControlName="email" autocomplete="email"
            [attr.aria-invalid]="(submitted || f['email'].touched) && f['email'].invalid ? 'true' : 'false'" />
          <span class="ac-error" *ngIf="(submitted || f['email'].touched) && f['email'].hasError('required')" aria-live="polite">{{ "signup.Email" | translate }}</span>
          <span class="ac-error" *ngIf="submitted && !f['email'].hasError('required') && f['email'].invalid" aria-live="polite">{{ "signup.valid" | translate }}</span>
        </div>

        <div class="ac-field">
          <label for="ac-why">{{ "contactPage.message" | translate }}</label>
          <textarea id="ac-why" formControlName="additional_info"></textarea>
        </div>

        <button class="ac-btn" type="submit" [disabled]="isLoading">{{ "contactPage.submit" | translate }}</button>
      </form>

      <hr class="ac-card__divider" />
      <p class="ac-card__alt">
        {{ "authPages.haveAccount" | translate }}
        <a [routerLink]="['/login']">{{ "login.signin" | translate }}</a>
      </p>
    </section>
  </main>

  <app-auth-footer></app-auth-footer>
</div>
